<div class="container mt-4">
  <div class="row justify-content-center mt-5">
    <div class="col-md-4 mt-lg-5 mt-5">
      <div class="card shadow-lg">
        <div class="card-header text-white">
          <h4 class="mb-0"><i class="fas fa-user-lock"></i> {{"TITLE.PASSWORD-UPDATE" | translate}}</h4>
        </div>
        <div class="alert alert-warning mb-0">
          <p class="text-decoration-none"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            {{"TITLE.IOFESIGN-REQUIRED-CHANGE-PASSWORD" | translate}}
          </p>
        </div>
        <div class="card-body">
          <form [formGroup]="changePasswordForm">
            <div class="form-group">
              <label for="newPassword">{{"MESSAGE.NEW-PASSWORD" | translate}}</label>
              <div class="input-group">
                <input [type]="showNewPassword ? 'text' : 'password'" class="form-control"
                       id="newPassword"
                       formControlName="newPassword"
                       required placeholder="{{'MESSAGE.ENTER-NEW-PASSWORD' | translate}}"
                       (keyup)="validatePassword()">
                <div class="input-group-append"> <span class="input-group-text">
                  <i class="fa {{showNewPassword?'fa-eye':'fa-eye-slash'}}"
                     (click)="toggleShowNewPassword()"></i>
                </span>
                </div>
              </div>
              <label *ngIf="isSecurityHigh">{{"LABEL.SECURITY-LEVEL" | translate}}:
                <b class="text-primary">{{"LABEL.HIGH" | translate}}</b></label>
              <label *ngIf="isSecurityMedium">{{"LABEL.SECURITY-LEVEL" | translate}}:
                <b class="text-success">{{"LABEL.MEDIUM" | translate}}</b></label>
              <label *ngIf="isSecurityLow">{{"LABEL.SECURITY-LEVEL" | translate}}:
                <b class="text-secondary">{{"LABEL.LOW" | translate}}</b></label>
              <ul class="mt-2">
                <li class="{{passwordControls?.isValidLength ? 'text-success':'text-danger'}}"
                    *ngIf="isSecurityHigh">
                  <i class="{{passwordControls?.isValidLength ? 'fas fa-check': 'fas fa-times'}}"></i>
                  {{"MESSAGE.MINIMUM-LENGTH-12" | translate}}
                </li>
                <li class="{{passwordControls?.isValidLength ? 'text-success':'text-danger'}}"
                    *ngIf="isSecurityMedium">
                  <i class="{{passwordControls?.isValidLength ? 'fas fa-check': 'fas fa-times'}}"></i>
                  {{"MESSAGE.MINIMUM-LENGTH-8" | translate}}
                </li>
                <li class="{{passwordControls?.isValidLength ? 'text-success':'text-danger'}}"
                    *ngIf="isSecurityLow">
                  <i class="{{passwordControls?.isValidLength ? 'fas fa-check': 'fas fa-times'}}"></i>
                  {{"MESSAGE.MINIMUM-LENGTH-6" | translate}}
                </li>
                <li class="{{passwordControls?.hasUpperCase ? 'text-success':'text-danger'}}"
                    *ngIf="!isSecurityLow">
                  <i class="{{passwordControls?.hasUpperCase ? 'fas fa-check': 'fas fa-times'}}"></i>
                  {{"MESSAGE.CONTAINS-CAPITAL-LETTER" | translate}}
                </li>
                <li class="{{passwordControls?.hasLowerCase ? 'text-success':'text-danger'}}"
                    *ngIf="!isSecurityLow">
                  <i class="{{passwordControls?.hasLowerCase ? 'fas fa-check': 'fas fa-times'}}"></i>
                  {{"MESSAGE.CONTAINS-LOWERCASE-LETTER" | translate}}
                </li>
                <li class="{{passwordControls?.hasNumber ? 'text-success':'text-danger'}}"
                    *ngIf="!isSecurityLow">
                  <i class="{{passwordControls?.hasNumber ? 'fas fa-check': 'fas fa-times'}}"></i>
                  {{"MESSAGE.CONTAINS-A-NUMBER" | translate}}
                </li>
                <li class="{{passwordControls?.hasSpecialChar ? 'text-success':'text-danger'}}"
                    *ngIf="!isSecurityLow && !isSecurityMedium">
                  <i class="{{passwordControls?.hasSpecialChar ? 'fas fa-check': 'fas fa-times'}}"></i>
                  {{"MESSAGE.CONTAINS-SPECIAL-CHARACTER" | translate}}
                </li>
              </ul>
              <small
                *ngIf="changePasswordForm.get('newPassword').errors?.passwordComplexity && changePasswordForm.get('newPassword').touched"
                class="text-danger">
                {{"MESSAGE.PASSWORD-REQUIRED-MUST-MEET-REQUIREMENTS" | translate}}
              </small>
            </div>
            <div class="form-group">
              <label for="confirmPassword">{{"MESSAGE.CONFIRM-NEW-PASSWORD" | translate}}</label>
              <div class="input-group">
                <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control"
                       id="confirmPassword"
                       formControlName="confirmPassword" required
                       placeholder="{{'LABEL.REPEAT-PASSWORD' | translate}}"
                       (keyup)="validatePassword()">
                <div class="input-group-append"> <span class="input-group-text">
                  <i class="fa {{showConfirmPassword?'fa-eye':'fa-eye-slash'}}"
                     (click)="toggleShowConfirmPassword()"></i>
                </span>
                </div>
              </div>
              <div *ngIf="changePasswordForm.errors?.mismatch && changePasswordForm.get('confirmPassword').touched"
                   class="text-danger">
                {{"MESSAGE.PASSWORDS-DO-NO-MATCH" | translate}}
              </div>
            </div>
            <button type="submit" class="btn btn-success btn-lg w-100"
                    (click)="submit()">{{"BUTTON.SAVE" | translate}}</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
